import {
  CommunicationProvider,
  SalesAppCommunicationProvider,
} from '@interhyp/module-communication';
import { FooterContext } from '@interhyp/platform-layout';
import { useApplicationContext } from '@interhyp/util-application-context';
import { ErrorBoundary } from '@interhyp/util-react-errors';
import { Toaster } from '@platform/elements';
import React from 'react';

import styles from './Viewport.module.scss';
import { Footer } from '../../components/Footer';
import { Navigation } from '../../components/Navigation/Navigation';
import { Router } from '../../components/Router/Router';

export function Viewport() {
  const { permissionsInitialized } = useApplicationContext();

  if (!permissionsInitialized) {
    return null;
  }

  return (
    <FooterContext
      footer={
        <ErrorBoundary moduleName="footer">
          <Footer />
        </ErrorBoundary>
      }
    >
      <CommunicationProvider>
        <SalesAppCommunicationProvider>
          <Toaster />
          <ErrorBoundary moduleName="header">
            <Navigation />
          </ErrorBoundary>
          <ErrorBoundary moduleName="main">
            <Router />
          </ErrorBoundary>
        </SalesAppCommunicationProvider>
      </CommunicationProvider>
    </FooterContext>
  );
}
